

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { EmployeeStatusSetup } from "../../components/EmployeeStatusSetup/EmployeeStatusSetup";


export const EmployeeStatusSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Employee Status Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Employee Status", navigateTo: "/employee/status/list" },
        { text: "Create Employee Status", navigateTo: "/employee/status/setup" }
      ]}
      mainContents={<EmployeeStatusSetup />}
    />
  );
};
